let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("45AU7")).then(() => parcelRequire('7RvJI'));